import React from 'react';
import styles from './styles.module.scss';

interface IRangeProps {
  radius: number;
  setRadius: React.Dispatch<React.SetStateAction<number>>;
}

export const Range = ({ radius, setRadius }: IRangeProps) => {
  return (
    <div className={styles.range}>
      <input
        type="number"
        aria-describedby="helper-text-explanation"
        className={styles.rangeInput}
        placeholder="999"
        required
        onChange={(e) => setRadius(Number(e.target.value))}
        value={radius}
      />
    </div>
  );
};
